/**
 * The theme turns off label clipping because the app trims text to cap height, which would clip the clause
 * name. Restoring the full text box lets a long label truncate inside the chip instead of overflowing it.
 */
export const CLAUSE_CHIP_CLASS_NAME =
	'max-w-72 font-mono [&_.MuiChip-label]:overflow-hidden [&_.MuiChip-label]:[text-box:initial]';
